import { render, staticRenderFns } from "./CompraDadosBasicosEmpresa.vue?vue&type=template&id=1030bc1c"
import script from "./CompraDadosBasicosEmpresa.vue?vue&type=script&lang=js"
export * from "./CompraDadosBasicosEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports